/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import baseStyles from '@salesforce/retail-react-app/app/theme/components/project/swatch-group';

export default {
  ...baseStyles,

  variants: {
    ...baseStyles.variants,

    'card': (props) => ({
      swatchesWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 2,
      },
      swatch: {
        borderColor: props.selected ? 'black' : 'gray.200',
        borderRadius: 'md',
        borderStyle: 'solid',
        borderWidth: props.selected ? 0.5 : 0.25,
        display: 'block',
        height: 'auto',
        minWidth: 30,
        position: 'relative',
        transition: 'all 0.2s',
        _hover: {
          borderColor: props.selected ? 'black' : 'gray.300',
        },
        _focus: {
          outline: 'none',
          boxShadow: 'outline',
        },
        _disabled: {
          opacity: 0.6,
          cursor: 'not-allowed',
        },
      },
      swatchButton: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: 3,
      },
      popularBadge: {
        position: 'absolute',
        top: 2,
        left: 2,
        backgroundColor: 'gray.700',
        color: 'white',
        fontSize: 'xs',
        fontWeight: 'semibold',
        padding: [0.5, 1.5],
        borderRadius: 'sm',
        zIndex: 1,
      },
      thumbnail: {
        width: 15,
        height: 15,
        minWidth: 15,
        minHeight: 15,
        marginBottom: 2,
        borderRadius: 'sm',
        overflow: 'hidden',
        flexShrink: 0,
      },
      thumbnailImage: {
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        width: '100%',
        height: '100%',
        border: '1px solid',
        borderColor: 'gray.300',
      },
      thumbnailFallback: {
        width: '100%',
        height: '100%',
        backgroundColor: 'gray.100',
        border: '1px solid',
        borderColor: 'gray.300',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      thumbnailFallbackText: {
        fontSize: 'xs',
        color: 'gray.500',
      },
      label: {
        fontSize: 'sm',
        fontWeight: 'normal',
        color: 'gray.900',
        textAlign: 'center',
        marginTop: 2,
      },
      link: {
        textDecoration: 'none',
        display: 'block',
      },
    }),
    'list-item': (props) => ({
      swatch: {
        display: 'flex',
        alignItems: 'center',
        padding: 4,
        backgroundColor: 'white',
        borderRadius: 'md',
        borderWidth: 0.5,
        borderStyle: 'solid',
        borderColor: props.selected ? 'black' : 'gray.200',
        minHeight: 16,
        transition: 'all 0.2s',
        width: '100%',
        cursor: props.disabled ? 'not-allowed' : 'pointer',
        _hover: props.disabled ? {} : {
          borderColor: props.selected ? 'black' : 'gray.300',
        },
        _focus: {
          outline: 'none',
          boxShadow: 'outline',
        },
        opacity: props.disabled ? 0.6 : 1,
      },
      swatchButton: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        padding: 0,
      },
      thumbnail: {
        width: 20,
        height: 20,
        minWidth: 20,
        minHeight: 20,
        marginRight: 4,
        borderRadius: 'sm',
        overflow: 'hidden',
        flexShrink: 0,
      },
      thumbnailImage: {
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        width: '100%',
        height: '100%',
        border: '1px solid',
        borderColor: 'gray.300',
      },
      thumbnailFallback: {
        width: '100%',
        height: '100%',
        backgroundColor: 'gray.100',
        border: '1px solid',
        borderColor: 'gray.300',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      thumbnailFallbackText: {
        fontSize: 'xs',
        color: 'gray.500',
      },
      label: {
        flex: 1,
        marginRight: 4,
      },
      labelText: {
        fontSize: 'md',
        fontWeight: 'normal',
        color: 'gray.900',
      },
      price: {
        marginRight: 4,
        textAlign: 'right',
        minWidth: 30,
        flexShrink: 0,
        color: 'brandColors.greyscale90',
      },
      radio: {
        width: 6,
        height: 6,
        minWidth: 6,
        minHeight: 6,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      },
    }),
  },

  parts: [
    ...baseStyles.parts,
    'swatchesWrapper',
    'swatchButton',
    'popularBadge',
    'thumbnail',
    'thumbnailImage',
    'thumbnailFallback',
    'thumbnailFallbackText',
    'label',
    'labelText',
    'price',
    'radio',
    'radioControl',
    'link'
  ],
};
